/**
 * Lightbox class.
 *
 */
class Lightbox {
	/**
	 * Constructor.
	 *
	 * @param {HTMLElement} figureElement Figure element.
	 */
	constructor( figureElement ) {
		this.figureElement = figureElement;
		this.imageTrigger = figureElement.querySelector( 'img' );
		this.imageUrl = this.imageTrigger.src;
		this.captionElement = figureElement
			.querySelector( 'figcaption' )
			?.cloneNode( true );

		this.setupLightboxElements();
		this.attachEventListeners();
	}

	/**
	 * Setup lightbox elements.
	 */
	setupLightboxElements() {
		// Lightbox wrapper
		this.lightboxWrapper = document.createElement( 'div' );
		this.lightboxWrapper.className = 'rt-lightbox-wrapper';
		this.lightboxWrapper.style.display = 'none';

		// Lightbox container
		const lightbox = document.createElement( 'div' );
		lightbox.className = 'rt-lightbox';

		// Content container
		this.contentContainer = document.createElement( 'div' );
		this.contentContainer.className = 'rt-lightbox-content';

		// Image
		const img = document.createElement( 'img' );
		img.src = this.imageUrl;
		img.alt = this.imageTrigger.alt;

		// Append the image and caption to the content container
		this.contentContainer.appendChild( img );
		if ( this.captionElement ) {
			this.contentContainer.appendChild( this.captionElement );
		}

		// Close button
		const closeButton = document.createElement( 'a' );
		closeButton.href = '#';
		closeButton.className = 'rt-lightbox-close';
		closeButton.onclick = this.closeLightbox;

		// Append the lightbox elements
		lightbox.appendChild( this.contentContainer );
		lightbox.appendChild( closeButton );

		// Append the lightbox to the wrapper
		this.lightboxWrapper.appendChild( lightbox );
		document.body.appendChild( this.lightboxWrapper );
	}

	/**
	 * Attach event listeners.
	 */
	attachEventListeners() {
		// Open the lightbox
		this.figureElement.onclick = this.openLightbox;
		this.figureElement.onkeydown = ( event ) => {
			if ( event.key === 'Enter' ) {
				this.openLightbox( event );
			}
		};
		this.lightboxWrapper.onclick = ( event ) => {
			if ( ! this.contentContainer.contains( event.target ) ) {
				this.closeLightbox();
			}
		};

		// Close the lightbox
		document.addEventListener( 'keydown', ( event ) => {
			if (
				event.key === 'Escape' &&
				this.lightboxWrapper.style.display === 'flex'
			) {
				this.closeLightbox();
			}
		} );
	}

	/**
	 * Open the lightbox.
	 *
	 * @param {Event} event Event object.
	 */
	openLightbox = ( event ) => {
		event.preventDefault();
		this.lightboxWrapper.style.display = 'flex';
	};

	/**
	 * Close the lightbox.
	 *
	 * @param {Event} event Event object.
	 */
	closeLightbox = ( event ) => {
		if ( event ) {
			event.preventDefault();
		}
		this.lightboxWrapper.style.display = 'none';
	};
}

/**
 * Initialize the lightboxes.
 */
function initLightboxes() {
	const lightboxFigures = document.querySelectorAll(
		'figure.is-lightbox-enabled',
	);
	lightboxFigures.forEach( ( figure ) => new Lightbox( figure ) );
}

// Initialize the lightboxes on page load.
document.addEventListener( 'DOMContentLoaded', initLightboxes, { once: true } );
